import React, { Component, Fragment } from "react";
// import { Row } from "reactstrap";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

// import IntlMessages from "../../../helpers/IntlMessages";
// import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import SettingsTab from "../../../containers/vehicle-master-renewal/settings-tab";

class VehicleMasterRenewal extends Component {
  render() {
    // const { messages } = this.props.intl;
    // const messages = [];
    return (
      <Fragment>
        
        <h1> Vehicle Master Renewal </h1>
        <SettingsTab history={this.props.history} />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ vehicles }) => {
  const { all } = vehicles;
  return { vehiclesAll: all };
};

export default connect(mapStateToProps)(injectIntl(VehicleMasterRenewal));
